<h2 mat-dialog-title class="mat-title">
  {{heading}}
  <span (click)="closeDialog()" class="close-dialog">&#10006;</span>
</h2>
<mat-dialog-content>
  {{body}}
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button color="primary" mat-stroked-button (click)="closeDialog()">Cancel</button>
  <button color="primary" (click)="logOut()" mat-raised-button>Yes, Logout</button>
</mat-dialog-actions>